import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React from 'react';
export default function getDataProps(props) {
  var result = {};
  Object.keys(props).forEach(function (key) {
    if (key.startsWith('data-')) result[key] = props[key];
  });
  return result;
}
export var useTraceUpdate = function useTraceUpdate(props) {
  var prev = React.useRef(props);
  React.useEffect(function () {
    var changedProps = Object.entries(props).reduce(function (ps, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          k = _ref2[0],
          v = _ref2[1];

      if (prev.current[k] !== v) ps[k] = [prev.current[k], v];
      return ps;
    }, {});
    if (Object.keys(changedProps).length > 0) console.log('Changed props:', changedProps);
    prev.current = props;
  });
};